import Vue from 'vue';
import VueStripeCheckout from 'vue-stripe-checkout';

const options = {
  key: process.env.STRIPE_PUBLISHABLE_KEY,
  locale: 'auto',
};

Vue.use(VueStripeCheckout, options);



// WEBPACK FOOTER //
// ./src/plugins/stripe-checkout.js